export const printLimit = 700;
export const zipLimit = 20;
